import { defineMessages, type IntlShape } from 'react-intl';

import { CompileSegmentedTaskError } from './compile-segmented-task';

/**
 * Toast copy for a failed task compile, keyed by
 * {@link CompileSegmentedTaskError.code}. The thrown error keeps its English
 * developer-facing `message`; the composers surface these instead.
 */
export const compileSegmentedTaskErrorMessages = defineMessages({
  workflow_not_found: {
    defaultMessage: 'Skill is unavailable',
    id: 'u3rqrbTEh/',
    description: 'Toast body when the referenced skill cannot be found',
  },
  empty_text_segment: {
    defaultMessage: 'Task is empty',
    id: 'K5ED9Yk7Cd',
    description: 'Toast body when the composed task has no content',
  },
  too_many_skill_refs: {
    defaultMessage: 'A task can include at most one skill.',
    id: 'NIjthbTC7J',
    description: 'Toast body when more than one skill is referenced in a task',
  },
  fallback: {
    defaultMessage: 'Selected skill is unavailable',
    id: 'X7+YkV5tn0',
    description: 'Toast body when compiling the task fails unexpectedly',
  },
});

/** Localized toast description for any error thrown by `compileSegmentedTask`. */
export const formatCompileSegmentedTaskError = (
  error: unknown,
  intl: IntlShape
): string =>
  intl.formatMessage(
    error instanceof CompileSegmentedTaskError
      ? compileSegmentedTaskErrorMessages[error.code]
      : compileSegmentedTaskErrorMessages.fallback
  );
